(function() {
  function findInShadows(selector, root = document) {
    const el = root.querySelector(selector);
    if (el) return el;
    const all = root.querySelectorAll('*');
    for (const node of all) {
      if (node.shadowRoot) {
        const found = findInShadows(selector, node.shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }

  const ejecutarInyeccionesReclamaciones = () => {
    const bloquePunto4 = document.querySelector('.point-four-claim-book');
    const bloqueLegal = document.querySelector('.claim-book-text-button');

    // 1. Procesar Punto 4
    const targetObs = findInShadows('textarea[name="custom#observaciones"]');
    if (targetObs && bloquePunto4) {
      const contenedor = targetObs.closest('[class*="_formFieldContainer"]') || targetObs.parentElement;
      if (contenedor && bloquePunto4.parentNode !== contenedor.parentNode) {
        contenedor.parentNode.insertBefore(bloquePunto4, contenedor);
        
        // FORZAR ESTILOS VÍA JS
        bloquePunto4.style.setProperty('display', 'block', 'important');
        const p4 = bloquePunto4.querySelector('p');
        if (p4) {
          p4.style.setProperty('margin', '0', 'important');
          p4.style.setProperty('padding', '0', 'important');
        }
      }
    }

    // 2. Procesar Bloque Legal
    const targetBtn = findInShadows('button[class*="_formSubmitButton"]');
    if (targetBtn && bloqueLegal) {
      if (bloqueLegal.parentNode !== targetBtn.parentNode) {
        targetBtn.parentNode.insertBefore(bloqueLegal, targetBtn);
        
        // FORZAR ESTILOS VÍA JS
        bloqueLegal.style.setProperty('display', 'block', 'important');
        const pLegal = bloqueLegal.querySelectorAll('p');
        pLegal.forEach(p => {
          p.style.setProperty('margin', '0', 'important');
          p.style.setProperty('padding', '0', 'important');
        });
      }
    }
  };

  let intentos = 0;
  const timer = setInterval(() => {
    ejecutarInyeccionesReclamaciones();
    intentos++;
    if (intentos > 20) clearInterval(timer);
  }, 1000);
})();